import React, { useState } from "react";
import { getAlertIconVentas } from "../utils/get";
import { getTanquesSifoneadosFluctuacionesCierreMensual } from "../utils/tanquesSifoneados";
import EditarIcon from "../../assets/img/EDITAR.svg";
import VerIcon from "../../assets/img/VER.svg";
import { getLocaleStringRoundedInt } from "../utils/utils";
import DetalleCierreMensualMobileModal from "./Responsive/DetalleCierreMensualMobileModal";
import JustificacionCierreMensualMobileModal from "./Responsive/JustificacionCierreMensualMobileModal";

const FluctuacionesTable = ({
  fluctuaciones,
  openJustificacion,
  estadoCierre,
  renderActionButton,
  selectedEds,
  selectedPeriodo,
  pagador,
  callServiceHandler,
  getCierreMensual
}) => {
  const [detalleModal, setDetalleModal] = useState({
    isOpen: false,
    title: "Fluctuaciones",
    subtitle: "",
    rows: [],
    isTotal: false
  });

  const [justificacionModal, setJustificacionModal] = useState({
    isOpen: false,
    info: null,
    selectedAction: "editar",
    title: "Fluctuaciones",
    subtitle: "",
    rows: []
  });

  const closeDetalleModal = () => {
    setDetalleModal({
      isOpen: false,
      title: "Fluctuaciones",
      subtitle: "",
      rows: [],
      isTotal: false
    });
  };

  const closeJustificacionModal = () => {
    setJustificacionModal({
      isOpen: false,
      info: null,
      selectedAction: "editar",
      title: "Fluctuaciones",
      subtitle: "",
      rows: []
    });
  };

  const getMaterialName = (material) => {
    return material === "KEROSENE" ? "KERO" : material;
  };

  const getPercentage = (value) => {
    if (value === null || value === undefined) return "-";
    return value.toString().replace(".", ",");
  };

  const getMaybeRestrictedValue = (value) => {
    if (estadoCierre === "ABIERTO" || estadoCierre === "REABIERTO" || estadoCierre === "EN REVISIÓN") {
      return "-";
    }

    return getLocaleStringRoundedInt(value);
  };

  const getAlertaContent = (alerta) => {
    return getAlertIconVentas(alerta) || "-";
  };

  const getJustificacionDisplayIcon = (justificacion) => {
    if (justificacion === "INGRESAR") {
      return <img className="cierre-mensual-justificar-icon" src={EditarIcon} alt="" />;
    }

    if (justificacion === "VER") {
      return <img className="cierre-mensual-justificar-icon" src={VerIcon} alt="" />;
    }

    return "-";
  };

  const getFluctuacionRows = () => {
    if (!fluctuaciones) return [];

    const rows = [];

    fluctuaciones.forEach((grupo, index) => {
      const materialInfo = {
        material: grupo.material,
        form_com: grupo.form_com
      };

      const tanques = grupo.tanques && grupo.tanques.length > 0 ? grupo.tanques : [grupo.total || grupo];

      tanques.forEach((tanque, tanqueIndex) => {
        rows.push({
          ...tanque,
          material: grupo.material,
          form_com: grupo.form_com,
          materialInfo,
          isTotal: false,
          key: `fluctuacion-${index}-${tanqueIndex}`
        });
      });

      if (grupo.tanques && grupo.tanques.length > 1 && grupo.total) {
        rows.push({
          ...grupo.total,
          tanque: "Total",
          material: grupo.material,
          form_com: grupo.form_com,
          materialInfo,
          isTotal: true,
          key: `fluctuacion-total-${index}`
        });
      }
    });

    return rows;
  };

  const buildFluctuacionRows = (row) => {
    const rows = [
      { label: "Med. Física Inicial", value: getLocaleStringRoundedInt(row.medicion_inicial) },
      { label: "(Lts) Entradas", value: getLocaleStringRoundedInt(row.entradas) },
      { label: "(Lts) Salidas", value: getLocaleStringRoundedInt(row.salidas) },
      { label: "(Lts) Fluct. Doc", value: getMaybeRestrictedValue(row.fluctuacion_documentada) },
      { label: "(Lts) Inv. Teórico", value: getLocaleStringRoundedInt(row.inventario_teorico) },
      { label: "Med. Física Proyectada", value: getLocaleStringRoundedInt(row.medicion_fisica_proyectada) },
      { label: "(Lts) Fluct. Calculada", value: getLocaleStringRoundedInt(row.fluctuacion_calculada_lts) },
      { label: "(%) Fluct. Calculada", value: getPercentage(row.fluctuacion_calculada_porcentaje) },
      { label: "Fluct. Confirmada", value: getLocaleStringRoundedInt(row.fluctuacion_confirmada_lts) },
      { label: "(%) Fluct. Confirmada", value: getPercentage(row.fluctuacion_confirmada_porcentaje) }
    ];

    if (!row.isTotal) {
      rows.push({ label: "Alerta", value: getAlertaContent(row.alerta) });
      rows.push({ label: "Justificación", value: getJustificacionDisplayIcon(row.justificacion) });
    }

    return rows;
  };

  const openFluctuacionDetalle = (row) => {
    setDetalleModal({
      isOpen: true,
      title: "Fluctuaciones",
      subtitle: row.isTotal ? `Total ${getMaterialName(row.material)}` : `${row.tanque} - ${getMaterialName(row.material)}`,
      rows: buildFluctuacionRows(row),
      isTotal: row.isTotal
    });
  };

  const openFluctuacionJustificacionMobile = (row, action) => {
    setJustificacionModal({
      isOpen: true,
      info: row,
      selectedAction: action,
      title: "Fluctuaciones",
      subtitle: `${row.tanque} - ${getMaterialName(row.material)}`,
      rows: buildFluctuacionRows(row)
    });
  };

  const getJustificacionContent = (row, isResponsive = false) => {
    if (row.isTotal) return "";

    if (row.justificacion === "INGRESAR") {
      return (
        <img
          className="cierre-mensual-justificar-icon"
          onClick={() => isResponsive ? openFluctuacionJustificacionMobile(row, "editar") : openJustificacion(row, row.materialInfo, "editar")}
          src={EditarIcon}
          alt=""
        />
      );
    }

    if (row.justificacion === "VER") {
      return (
        <img
          className="cierre-mensual-justificar-icon"
          onClick={() => isResponsive ? openFluctuacionJustificacionMobile(row, "ver") : openJustificacion(row, row.materialInfo, "ver")}
          src={VerIcon}
          alt=""
        />
      );
    }

    return "-";
  };

  const rows = getFluctuacionRows();

  return (
    <div className="cierre-mensual-table-section cierre-mensual-fluctuaciones-section">
      <div className="cierre-mensual-table-title-row">
        <div className="table-title">FLUCTUACIONES</div>
        <div className="cierre-mensual-table-title-action">
          {renderActionButton && renderActionButton()}
        </div>
      </div>

      <table className="table-with-material-title fluctuaciones cierre-mensual-desktop-table">
        <div className="table-header">
          <div className="legend">
            <div className="material"><div className="rect"></div><div className="text">Material Consignado</div></div>
            <div className="material"><div className="rect concesionado"></div><div className="text">Material Concesionado</div></div>
          </div>
        </div>
        <thead>
          <tr>
            <th className="no-padding-left" colSpan={2}><div className="th-data width-80"><div className="th-text">Material</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Med. Física<br />Inicial</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts)<br />Entradas</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts)<br />Salidas</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts)<br />Fluct. Doc</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts)<br />Inv. Teórico</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Med. Física<br />Proyectada</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts) Fluct.<br />Calculada</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(%) Fluct.<br />Calculada</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Fluct.<br />Confirmada</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(%) Fluct.<br />Confirmada</div></div></th>
            <th><div className="th-data width-60"><div className="th-text">Alerta</div></div></th>
            <th><div className="th-data width-60"><div className="th-text">Justifi...</div></div></th>
          </tr>
        </thead>
        <tr className="separator-table-row"><th colSpan="100%" /></tr>
        <tbody>
          {fluctuaciones && fluctuaciones?.map((tanque, key) =>
            getTanquesSifoneadosFluctuacionesCierreMensual(tanque, key, openJustificacion, estadoCierre)
          )}
        </tbody>
      </table>

      <table className="cierre-mensual-responsive-table cierre-mensual-fluctuaciones-responsive-table">
        <thead>
          <tr>
            <th><div className="th-data">Material</div></th>
            <th className="cm-tablet-only"><div className="th-data">Fluct.<br />Confirmada</div></th>
            <th className="cm-tablet-only"><div className="th-data">% Fluct.<br />Confirmada</div></th>
            <th><div className="th-data">Alerta</div></th>
            <th><div className="th-data">Justificación</div></th>
          </tr>
        </thead>
        <tbody>
          <tr className="separator-table-row"><th colSpan="100%" /></tr>
          {fluctuaciones ?
            <>
              {rows.length > 0 ?
                rows.map((row, index) => (
                  <React.Fragment key={row.key}>
                    <tr className={row.isTotal ? "cm-total-row" : ""}>
                      <td>
                        {row.isTotal ?
                          `Total ${getMaterialName(row.material)}`
                          :
                          <>
                            <div className="cm-material-main">{row.tanque}</div>
                            <div className="cm-material-sub">{getMaterialName(row.material)}</div>
                          </>
                        }
                      </td>
                      <td className="cm-tablet-only">
                        {row.isTotal ?
                          <div className="cm-total-pill">{getLocaleStringRoundedInt(row.fluctuacion_confirmada_lts)}</div>
                          :
                          getLocaleStringRoundedInt(row.fluctuacion_confirmada_lts)
                        }
                      </td>
                      <td className="cm-tablet-only">
                        {row.isTotal ?
                          <div className="cm-total-pill">{getPercentage(row.fluctuacion_confirmada_porcentaje)}</div>
                          :
                          getPercentage(row.fluctuacion_confirmada_porcentaje)
                        }
                      </td>
                      <td className="align-center cm-alert-cell">{!row.isTotal && getAlertIconVentas(row.alerta)}</td>
                      <td className="align-center cm-justification-cell">
                        <div className="cm-justification-content">
                          <span className="cm-justification-icon">{getJustificacionContent(row, true)}</span>
                          <button className="cm-row-arrow-button" onClick={() => openFluctuacionDetalle(row)}>
                            <span className="cm-row-arrow"></span>
                          </button>
                        </div>
                      </td>
                    </tr>
                    {index < rows.length - 1 && <tr className="separator-table-row"><th colSpan="100%" /></tr>}
                  </React.Fragment>
                ))
                :
                <tr><td className="align-left" colSpan="5">No se encontró información de fluctuaciones del cierre.</td></tr>
              }
            </> :
            <tr><td className="align-left" colSpan="5">Busca por EDS y por Periodo.</td></tr>
          }
        </tbody>
      </table>

      <div className="cierre-mensual-mobile-section-action">
        {renderActionButton && renderActionButton()}
      </div>

      <DetalleCierreMensualMobileModal
        isOpen={detalleModal.isOpen}
        closeModal={closeDetalleModal}
        title={detalleModal.title}
        subtitle={detalleModal.subtitle}
        rows={detalleModal.rows}
        isTotal={detalleModal.isTotal}
      />

      <JustificacionCierreMensualMobileModal
        isOpen={justificacionModal.isOpen}
        closeModal={closeJustificacionModal}
        info={justificacionModal.info}
        selectedTable="FLUCTUACION"
        selectedAction={justificacionModal.selectedAction}
        selectedEds={selectedEds}
        selectedPeriodo={selectedPeriodo}
        pagador={pagador}
        callServiceHandler={callServiceHandler}
        getCierreMensual={getCierreMensual}
        estadoCierre={estadoCierre}
        title={justificacionModal.title}
        subtitle={justificacionModal.subtitle}
        rows={justificacionModal.rows}
      />
    </div>
  );
};

export default FluctuacionesTable;
